import React, { lazy, Suspense } from 'react'
import { TaskService } from '@duck/api-definitions'
import { useTar } from '@/modules'
import { StandardLoader } from '@/components/StandardLoader'
import { TaskFormField } from './TaskFormField'

const CodeInput = lazy(() => import('../DataWorkspace/CodeInput').then(module => ({ default: module.CodeInput })))

interface DataSectionProps {
  formData: Partial<TaskService.Task>
  onChange: (field: keyof TaskService.Task, value: string | number | string[] | undefined) => void
  fieldErrors?: Record<string, string>
}

export const DataSection: React.FC<DataSectionProps> = ({
  formData,
  onChange,
  fieldErrors = {},
}) => {
  const { t } = useTar()

  return (
    <div className="space-y-6">
      <div className="space-y-4">
        <h3 className="text-lg font-medium text-foreground border-b border-border pb-2">
          {t('common.data')}
        </h3>
        <div className="space-y-2 flex flex-col h-[340px]">
          <label className="block text-sm font-medium text-foreground">
            {t('tasks.dataBank')}
            <span className="text-error ms-1">*</span>
          </label>
          <Suspense
            fallback={
              <div className="border border-border pt-2 bg-background h-[280px] flex items-center justify-center">
                <StandardLoader size="md" />
              </div>
            }
          >
            <CodeInput
              query={formData.dataBank ?? ''}
              onQueryChange={(val) => onChange('dataBank', val)}
              language={'JSON'}
            />
          </Suspense>
          {fieldErrors.dataBank && (
            <p className="text-sm text-error mt-1">{fieldErrors.dataBank}</p>
          )}
        </div>
        <div>
          <TaskFormField
            label="tasks.defaultQuery"
            field="defaultQuery"
            type="textarea"
            required
            formData={formData}
            onChange={onChange}
            fieldErrors={fieldErrors}
          />
        </div>
      </div>
    </div>
  )
}
